import React from "react";
import { InputText } from "iuvity-ui-components/dist/inputtext";
import { InputSwitch } from "primereact/inputswitch";
import { KeyFilterType } from "primereact/keyfilter";
import { Tooltip } from "primereact/tooltip";

export interface InputTextProps {
  label: string;
  id?: string;
  style?: React.CSSProperties;
  className?: string;
  value?: string | number | readonly string[];
  type?: React.HTMLInputTypeAttribute;
  placeholder?: string;
  keyfilter?: KeyFilterType;
  isImportant?: boolean;
  hasTooltip?: boolean;
  tooltipText?: string;
  name?: string;
  disabled?: boolean
  [key: string]: any
}

export const CustomInput = React.forwardRef<any, InputTextProps>(
  (
    {
      label,
      value,
      id = "input-text",
      type = "text",
      hasTooltip = false,
      tooltipText = "",
      placeholder = "",
      className = "",
      style,
      name,
      keyfilter,
      disabled = false,
      ...props
    },
    ref
  ) => {

    return (
      <React.Fragment>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
          }}
        >
          <label
            htmlFor={id}
            className={`mb-2 block lb ${
              disabled ? "p-disabled label-disabled" : ""
            }`}
          >
            {label}
            {hasTooltip ? (
              <span
                className={`tooltip-inputtext iu iu-icon-info ${
                  disabled ? "p-disabled label-disabled" : ""
                } tooltip-id-${id}`}
                style={{
                  color: "var(--successColor)",
                  marginLeft: "1rem",
                }}
              >
                <Tooltip target={`.tooltip-id-${id}`} position="bottom">
                  <p>{tooltipText}</p>
                </Tooltip>
              </span>
            ) : null}
          </label>
        </div>
        <span className="p-input-icon">
          {type === "boolean" ? (
            <InputSwitch
              className={`block ${className} mt-1`}
              checked={`${value}`.toLowerCase() === "true"}
              {...props}
            />
          ) : (
            <InputText
              id={id}
              className={`block ${className}`}
              style={style}
              value={value}
              disabled={disabled}
              placeholder={placeholder}
              autoComplete="off"
              tooltip={hasTooltip ? tooltipText : ""}
              keyfilter={keyfilter}
              type={type}
              name={name}
              ref={ref}
              {...props}
            />
          )}
        </span>
      </React.Fragment>
    );
  }
);
